import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=600ea0ec&scoped=true&"
import script from "./LogoImage.vue?vue&type=script&lang=ts&"
export * from "./LogoImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ea0ec",
  null
  
)

export default component.exports